<div fxLayout="row" class="wrapper">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Recording ...</span>
</div>
<!-- <div *ngIf="data === RecorderTypes.VIDEO" fxLayout="row" class="wrapper">
    <video id="video-preview" type="video/mp4" autoplay playsinline>
     <source src="https://nk3mp4.s3-eu-central-1.amazonaws.com/materials/5/2022_06_01_190314_KLMS_recorded_screen_220601_1903.mp4" type="video/webm" />
    </video>
</div> -->
